import { Brand, createBranded } from '@deltasierra/type-utilities';
import { HasId, Auditable } from '../common/model/traits';
import { LocationId } from '../location/Location';
import { PathBuilder, ApiRoute, HttpMethod } from '../common/api/routes';
import { Url } from '../common/lang/web';
import { ClientId } from '../client';
import { AgencyId, AgencyApiParams, AGENCY_API_ROOT, AGENCIES_COLLECTION_API_ROOT } from './Agency';

export type AgencyNotificationId = Brand<number, 'AgencyNotificationId'>;
export const AgencyNotificationId = createBranded<AgencyNotificationId>();

export enum AgencyNotificationsNotificationEnum {
    EMAIL = 'email',
    PUSH = 'push',
}

export type AgencyNotificationsNotificationType = `${AgencyNotificationsNotificationEnum}`;

export interface AgencyNotification extends HasId<AgencyNotificationId>, Auditable {
    agencyId: AgencyId;
    groupingId?: string;
    sendgridEmailId: string | null;
    notificationType: AgencyNotificationsNotificationType;
    filteredByTitles?: string[] | null;
    fromName: string | null;
    fromEmailLocalPart: string | null;
    fromEmailDomainPart: string | null;
    usedClientId: ClientId | null;
    subject: string;
    message: string;
    link: Url | null;
    sentAt?: Date | null;
}

export interface AgencyNotificationWithReporting {
    agencyNotification: AgencyNotification;
    totalSent: number;
    totalClicked: number;
}

const AGENCY_NOTIFICATIONS_API_ROOT = <T extends AgencyApiParams>(path: PathBuilder<T>) =>
    AGENCY_API_ROOT(path).literal('notifications');

export interface AgencyEmailNotificationSenderInfo {
    fromEmailLocalPart: string;
    fromEmailDomainPart: string;
    fromName: string;
    clientId: ClientId;
}

export interface CreateAgencyNotificationBody {
    filteredByTitles?: string[] | null;
    link?: Url | null;
    locations: LocationId[];
    message: string;
    subject: string;
}

export interface CreateAgencyEmailNotificationBody extends CreateAgencyNotificationBody {
    senderInfo?: AgencyEmailNotificationSenderInfo | null;
}

export const AgencyNotificationsApi = {
    createNotification: new ApiRoute<AgencyNotification, AgencyApiParams, CreateAgencyNotificationBody, void>(
        HttpMethod.Post,
        AGENCY_NOTIFICATIONS_API_ROOT,
    ),
    getAgencyNotifications: new ApiRoute<AgencyNotificationWithReporting[], void, void, void>(HttpMethod.Get, path =>
        AGENCIES_COLLECTION_API_ROOT(path).literal('notifications').literal('report'),
    ),
};

export interface SendAgencyNotificationWorkflowInput {
    scheduledTime: string;
    agencyNotificationId: AgencyNotificationId;
}
